import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({ name: 'timezoneDate' })
export class TimezoneDatePipe implements PipeTransform {
  transform(value: string | Date, timezone: string, locale: string): string {
    if (!value || !timezone || !locale) {
      return '';
    }
    const date = moment(value).tz(timezone).locale(locale);
    return date.format('L, hh:mm A z');
  }
}
